import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import pl from "../locales/pl.json";
import nl from "../locales/nl.json";
import de from "../locales/de.json";
import it from "../locales/it.json";
import fr from "../locales/fr.json";
import es from "../locales/es.json";
import pt from "../locales/pt.json";

export const LANGUAGES = [
    { code: "en", label: "English" },
    { code: "de", label: "Deutsch" },
    { code: "fr", label: "Français" },
    { code: "es", label: "Español" },
    { code: "it", label: "Italiano" },
    { code: "pt", label: "Português" },
    { code: "nl", label: "Nederlands" },
    { code: "pl", label: "Polski" },
];

export const SUPPORTED_LANG_CODES = LANGUAGES.map((l) => l.code);

// Country-qualified hreflang targets. Each language page is announced to every
// market that actually speaks it, so Google serves /nl to Belgian buyers and
// /pt to Brazilian ones. Chosen to match the 32 export destinations we ship to.
export const HREFLANG_REGIONS = {
    en: ["en", "en-US", "en-GB", "en-CA", "en-AU", "en-NZ", "en-IE", "en-IN", "en-SG", "en-AE", "en-ZA"],
    de: ["de", "de-DE", "de-AT", "de-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CH", "fr-CA", "fr-LU"],
    es: ["es", "es-ES", "es-MX"],
    it: ["it", "it-IT", "it-CH"],
    pt: ["pt", "pt-PT", "pt-BR"],
    nl: ["nl", "nl-NL", "nl-BE"],
    pl: ["pl", "pl-PL"],
};

// og:locale wants language_TERRITORY.
export const OG_LOCALE = {
    en: "en_US",
    de: "de_DE",
    fr: "fr_FR",
    es: "es_ES",
    it: "it_IT",
    pt: "pt_PT",
    nl: "nl_NL",
    pl: "pl_PL",
};

const detectInitialLanguage = () => {
    const path = window.location.pathname.split("/").filter(Boolean)[0];
    if (path && SUPPORTED_LANG_CODES.includes(path)) return path;
    const stored = localStorage.getItem("lang");
    if (stored && SUPPORTED_LANG_CODES.includes(stored)) return stored;
    const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
    if (SUPPORTED_LANG_CODES.includes(nav)) return nav;
    return "en";
};

i18n.use(initReactI18next).init({
    resources: {
        en: { common: en },
        pl: { common: pl },
        nl: { common: nl },
        de: { common: de },
        it: { common: it },
        fr: { common: fr },
        es: { common: es },
        pt: { common: pt },
    },
    lng: detectInitialLanguage(),
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: { escapeValue: false },
    returnObjects: true,
});

export default i18n;
